import { createContext } from 'react';
import { type RouterContextDataFragment } from '../../../api/fragments/RouterContextData';
import { type RouteDefinition } from '../../../utilities/getRoutesFromRouter';

export type RouterContextPayload = RouterContextDataFragment & { refetch: () => Promise<unknown> };

export const RouterContext = createContext<RouterContextPayload | null>(null);
export const RouterRoutesContext = createContext<RouteDefinition[]>([]);
